module.exports = __webpack_public_path__ + "img/Doppelbindung.dc3542c6.jpg";